import ConfigDB from '../../../Config/ThemeConfig';
import { CompletedGoal, ExpectedGoal } from '../../../Constant';

const primary = ConfigDB.color.primary_color;
export const GoalOverviewOptions = {
  series: [
    {
      name: ExpectedGoal,
      type: 'area',
      data: [50, 40, 48, 47, 50],
    },
    {
      name: CompletedGoal,
      type: 'line',
      data: [40, 50, 35, 42, 45],
    },
  ],
  options: {
    chart: {
      height: 235,
      type: 'line',
      toolbar: {
        show: false,
      },
    },
    stroke: {
      curve: 'smooth',
      width: [5, 2],
      dashArray: [0, 8],
    },
    fill: {
      type: 'solid',
      opacity: [0.35, 1],
    },
    markers: {
      size: [7, 0],
      colors: ['#fff'],
      strokeColor: primary,
      strokeWidth: [4, 0],
    },
    yaxis: {
      show: false,
    },
    grid: {
      borderColor: '#ffffff',
    },
    xaxis: {
      show: false,
      labels: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (y) {
          if (typeof y !== 'undefined') {
            return y.toFixed(0) + ' points';
          }
          return y;
        },
      },
    },
    legend: {
      show: false,
    },
    responsive: [
      {
        breakpoint: 1741,
        options: {
          chart: {
            height: 225,
          },
        },
      },
      {
        breakpoint: 1661,
        options: {
          chart: {
            height: 255,
          },
        },
      },
      {
        breakpoint: 1441,
        options: {
          chart: {
            height: 255,
          },
        },
      },
      {
        breakpoint: 1366,
        options: {
          chart: {
            height: 245,
          },
        },
      },
      {
        breakpoint: 1200,
        options: {
          chart: {
            height: 250,
          },
        },
      },
    ],

    colors: [primary],
  },
};

// Browser StatisticsData //
export const BrowserStatisticsData = [
  {
    series: [
      {
        name: 'Internet Explorer',
        data: [56],
      },
    ],
  },
  {
    series: [
      {
        name: 'Google Chrome',
        data: [95],
      },
    ],
  },
  {
    series: [
      {
        name: 'Opera',
        data: [70],
      },
    ],
  },
  {
    series: [
      {
        name: 'Firefox',
        data: [55],
      },
    ],
  },
];

// Progress bar  //
export const progressOptions = {
  chart: {
    height: 75,
    type: 'bar',
    stacked: true,
    fontFamily: 'Rubik,sans-serif',
    sparkline: {
      enabled: true,
    },
  },
  plotOptions: {
    bar: {
      horizontal: true,
      barHeight: '9px',
      colors: {
        backgroundBarColors: ['#e2e7f8'],
      },
    },
  },
  colors: [primary],
  stroke: {
    width: 0,
  },
  fill: {
    colors: [primary],
    type: 'gradient',
    opacity: 1,
    gradient: {
      gradientToColors: [primary],
    },
  },

  title: {
    floating: true,
    offsetX: -10,
    offsetY: 5,
    text: '',
    style: {
      fontWeight: '700',
    },
  },
  subtitle: {
    floating: true,
    align: 'right',
    offsetY: 0,
    text: '56%',
    style: {
      fontSize: '18px',
    },
  },
  tooltip: {
    enabled: false,
  },
  xaxis: {
    categories: ['Internet Explorer'],
  },
  yaxis: {
    max: 100,
  },
};

// total profit start//
export const totalProfitOption = {
  series: [
    {
      name: 'Total Profit',
      type: 'column',
      data: [20, 20, 40, 30, 60, 50, 35, 25, 50, 45, 55, 60, 20, 45, 20, 20],
    },
    {
      name: 'Total Profit',
      type: 'area',
      data: [50, 50, 45, 55, 50, 60, 56, 58, 50, 65, 60, 50, 60, 52, 55, 55],
    },
  ],
  options: {
    chart: {
      height: 300,
      type: 'bar',
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '20px',
        startingShape: 'rounded',
        endingShape: 'rounded',
        borderRadius: 5,
      },
    },
    fill: {
      opacity: [1, 0.05],
      gradient: {
        type: 'vertical',
        opacityFrom: 0.5,
        opacityTo: 0.1,
        stops: [100, 100, 100],
      },
    },
    stroke: {
      show: false,
    },
    legend: {
      show: false,
    },
    grid: {
      show: false,
      padding: {
        top: -35,
        right: -45,
        bottom: 0,
        left: -35,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      axisBorder: {
        show: false,
      },
      labels: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        show: false,
      },
    },
    responsive: [
      {
        breakpoint: 1661,
        options: {
          chart: {
            height: 287,
          },
        },
      },

      {
        breakpoint: 1574,
        options: {
          chart: {
            height: 230,
          },
        },
      },
      {
        breakpoint: 1470,
        options: {
          chart: {
            height: 185,
          },
        },
      },
    ],

    colors: [primary],
  },
};
